import React from 'react';

import cn from 'classnames';

import Message from 'components/Message';
import Typography, { TypographyVariant } from 'components/Typography';

import { IntlMsgShape } from 'helpers/consts';

export type Heading = string | IntlMsgShape;
export type HeadingGap = 'gap-1' | 'gap-2' | 'gap-4' | 'gap-6';

export type HeadingConfig = {
  gap?: HeadingGap;
  titleVariant?: TypographyVariant;
  titleAlignCenter?: boolean;
  subtitleAlignCenter?: boolean;
  subtitleVariant?: TypographyVariant;
  withNonBleeding?: boolean;
};

export interface IProps {
  title?: Heading;
  subtitle?: Heading;
  config?: HeadingConfig;
}

const Headings = ({
  title,
  subtitle,
  config: {
    gap = 'gap-4',
    titleVariant = 'h1',
    titleAlignCenter = true,
    subtitleAlignCenter,
    subtitleVariant = 'body',
    withNonBleeding = false,
  } = {},
}: IProps) => {
  const shouldRender = title || subtitle;

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className={cn('Headings flex flex-col', gap, {
        'mx-6': withNonBleeding,
      })}
    >
      {title && (
        <Typography variant={titleVariant} centered={titleAlignCenter}>
          <Message message={title} />
        </Typography>
      )}

      {subtitle && (
        <Typography variant={subtitleVariant} centered={subtitleAlignCenter}>
          <Message message={subtitle} />
        </Typography>
      )}
    </div>
  );
};

export default Headings;
